/** One Visit task change tag shared by record header and list presentation. */
import { PlannedTaskLine } from '@jms/model/entities/planned.work/planned.task/planned.task';
import { defineConditionalTag } from '../../shared/define.conditional.tag';

export const plannedTaskChangeTag = defineConditionalTag<PlannedTaskLine>(task => task.visitChange ? { label: task.visitChange, tone: 'neutral' } : null);
